import { Divider, PageHeader, Tabs } from "antd";
import LayoutCss from "layout/layout.module.scss";
import { pick } from "lodash";
import { useSelector } from "react-redux";
import { InvoicesContainer } from "../../clients/details/invoices/InvoicesContainer";
import { useQueryState } from "../../../hooks/useQueryState";
import K from "../../../utilities/constants";
import { selectSelectedClientIds } from "../../../redux/slices/globalSelectorSlice";

const TabsConfig = {
  client: {
    key: "client",
    label: "Client",
    renderComponent: ({ clientIds }) => (
      <InvoicesContainer
        key="global-client-invoices"
        type={K.Invoice.Type.Client}
        clientIds={clientIds}
        filtersPrefix="global_client_invoices"
        tableConfigKey={K.AgGridTable.Keys.GlobalClientInvoicesVisibleColumn}
      />
    ),
  },
  job: {
    key: "job",
    label: "Job",
    renderComponent: ({ clientIds }) => (
      <InvoicesContainer
        key="global-job-invoices"
        type={K.Invoice.Type.Job}
        clientIds={clientIds}
        filtersPrefix="global_job_invoices"
        tableConfigKey={K.AgGridTable.Keys.GlobalClientJobInvoicesVisibleColumn}
      />
    ),
  },
};

export default function Invoices() {
  const clientIds = useSelector(selectSelectedClientIds);

  const [tab, setTab] = useQueryState("tab", TabsConfig.client.key);

  const activeTab = TabsConfig[tab];

  const tabItems = Object.values(TabsConfig).map((t) =>
    pick(t, ["key", "label"]),
  );

  return (
    <>
      <PageHeader
        ghost={false}
        title="Invoices"
        footer={
          <>
            <Divider className={LayoutCss.appPageHeaderDivider} />
            <Tabs
              activeKey={activeTab.key}
              onChange={setTab}
              className={LayoutCss.appPageHeaderTabs}
              items={tabItems}
            />
          </>
        }
        className={LayoutCss.appPageHeader}
      />

      {activeTab.renderComponent({ clientIds })}
    </>
  );
}
